import './vendor-styles'

import 'reflect-metadata'

import '@/polyfills'
import '@/plugins'
import '@/shared'
import '@/api'
import '@/authentication'
import '@/business'

import { bootstrap } from '@/bootstrap'
import { environmentConfiguration } from '@/config/environments'

import * as rootLogger from 'loglevel'

rootLogger.setLevel(environmentConfiguration().logLevel)

// Bootstrap the application
bootstrap().then(app => app.$mount('#app'))
